(function () {
  'use strict';

  /* Miniatura de la unidad según el color elegido */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var el = root.querySelector('[data-variants]');
    if (!el) return;
    var variants = JSON.parse(el.textContent);

    function variantFor(unit) {
      var vals = [].map.call(unit.querySelectorAll('select'), function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (variants[i].options[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function syncThumbs() {
      root.querySelectorAll('.unit').forEach(function (u) {
        var t = u.querySelector('[data-unit-thumb]');
        if (!t) return;
        var v = variantFor(u);
        if (v && v.img) t.src = v.img;
      });
    }
    root.addEventListener('change', syncThumbs);
  });

  /* Botón "Elegir este color" de la sección de colores */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pick-color]');
    if (!btn) return;
    e.preventDefault();
    var root = document.querySelector('[data-product]');
    if (!root) return;
    var color = btn.getAttribute('data-pick-color');
    var first = null;
    root.querySelectorAll('.unit').forEach(function (u) {
      u.querySelectorAll('select').forEach(function (s) {
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].value === color) {
            s.value = color;
            if (!first) first = s;
          }
        }
      });
    });
    if (first) first.dispatchEvent(new Event('change', { bubbles: true }));
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
